import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-semantics-donut-topic',
  templateUrl: './semantics-donut-topic.component.html',
  styleUrl: './semantics-donut-topic.component.scss',
})
export class SemanticsDonutTopicComponent {
  isLoading = true;

  options: echarts.EChartsOption = {
    legend: {
      orient: 'vertical',
      left: 'right',
      top: 'middle',
      type: 'scroll',
      height: 350, // or a percentage like '70%'
    },
    series: {
      center: ['44%', '50%'],
    },
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.semanticsDonutTopic$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('semanticsDonutTopic');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getSemanticsDonutTopic().subscribe();
  }

  get series() {
    return this.analyticsService.semanticsDonutTopic$.value?.series[0];
  }

  get labels() {
    return this.analyticsService.semanticsDonutTopic$.value?.labels;
  }
}
